import { AccrualCashComparisonSection } from "./creances-engagements/components/AccrualCashComparisonSection";
import { CreancesByPartySection } from "./creances-engagements/components/CreancesByPartySection";
import { OpenEngagementsSection } from "./creances-engagements/components/OpenEngagementsSection";
import { useCreancesEngagementsAnalytics } from "./creances-engagements/hooks/useCreancesEngagementsAnalytics";
import { ServicesLoadingState } from "./services/components/ServicesLoadingState";

interface CreancesEngagementsTabProps {
  from: string;
  to: string;
}

export function CreancesEngagementsTab({ from, to }: CreancesEngagementsTabProps) {
  const { creances, comparison, engagements, loading } = useCreancesEngagementsAnalytics({
    from,
    to,
  });

  if (loading || !comparison || !engagements) return <ServicesLoadingState />;

  return (
    <div className="space-y-6">
      <AccrualCashComparisonSection comparison={comparison} />
      <OpenEngagementsSection engagements={engagements} />
      <CreancesByPartySection creances={creances} />
    </div>
  );
}
